import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { compact, uniq } from 'lodash-es'

import { type AppViewNavigation } from '@/components/templates/AppView'
import { useTeams } from '@/model/contexts/useTeams.ts'

export function useTeamStartingLocationsDropdown(): Pick<AppViewNavigation, 'teamStartingLocationOptions'> {
  const intl = useIntl()
  const { teams } = useTeams()

  return useMemo(() => {
    const startingLocations = uniq(teams.map(({ startingLocation }) => startingLocation))
    return {
      teamStartingLocationOptions: {
        placeholder: intl.formatMessage({ id: 'selector.startingLocation.label' }),
        options: [
          {
            text: intl.formatMessage({ id: 'selector.startingLocation.all' }),
            value: 'all',
          },
          ...compact(startingLocations).map((value) => ({
            text: intl.formatMessage({ id: 'selector.startingLocation.value' }, { value }),
            value,
          })),
        ],
      },
    }
  }, [intl, teams])
}
